import * as React from 'react';
import * as Redux from 'redux';
import { connect } from 'react-redux';
import { translate } from "react-i18next";
import styled from 'styled-components';
import Hls from 'hls.js';
import { openDefault } from '../../../../actions/modules';

const StyledVideoWrapper = styled.div`
  position: relative;
  align-items: center;
  justify-content: center;
  display: flex;
  height: calc(100% - 3px);
  width: 100%;
  flex-direction: column;
  background-color: #242424;
  box-shadow: inset 0 0 5px rgba(0,0,0,0.75);
`;

const StyledVideo = styled.video`
  height: 99%;
  width: 99.5%;
`;

class StreamWrapper extends React.Component {
    videoPlayer = null;
    
    componentDidMount() {
        const { selected, isStreamTransmiting, hlsUrl, openDefault } = this.props;
        if (selected === 'stream' && !isStreamTransmiting) {
            openDefault();
            return;
        }

        if (!isStreamTransmiting) return;

        const video = this.videoPlayer;
        if (Hls.isSupported()) {
            const hls = new Hls();
            hls.loadSource(hlsUrl);
            hls.attachMedia(video);
            hls.on(Hls.Events.MANIFEST_PARSED, () => video.play());
        }
        else if (video.canPlayType('application/vnd.applempegurl')) {
            video.src = hlsUrl;
            video.addEventListener("canplay", () => video.play());
        }
    }

    componentDidUpdate() {
        const { selected, isStreamTransmiting, openDefault } = this.props;
        if (selected === 'stream' && !isStreamTransmiting) {
            openDefault();
            return;
        }
    }

    render() {
        return (
            <StyledVideoWrapper>
                <StyledVideo innerRef={(node) => { this.videoPlayer = node }} controls />
            </StyledVideoWrapper>
        );
    }
};

const mapStateToProps = state => ({
    selected: state.modules.get('selected'),
    isStreamTransmiting: state.video.get('isStreamTransmiting'),
    hlsUrl: state.video.get('hlsUrl'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    openDefault
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(StreamWrapper));


// WEBPACK FOOTER //
// ./src/containers/content/grid/streamWrapper/StreamWrapper.jsx